exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-page-wrapper[data-v-2fd2e5e4]{width:100%;padding-bottom:10px}", ""]);

// exports
